import axios from "axios";

import { LOADING_LOGS, FETCH_LOGS } from "./type";

// fetch all the logs
export const fetchLogs = (options, callback) => async (dispatch, getStore) => {
  // Skip fetch if logs for this bookId already loaded and skipIfLoaded is true (default)
  const skipIfLoaded = options?.skipIfLoaded !== false;
  if (skipIfLoaded && options?.bookId) {
    const { log } = getStore();
    const existingLogs = Object.values(log?.logMap || {});
    const logsForBook = existingLogs.filter(
      (l) => l.bookId === options.bookId || l._book === options.bookId
    );
    if (logsForBook.length > 0) {
      // Logs for this book already loaded, skip API call
      if (callback) callback();
      return;
    }
  }

  dispatch({
    type: LOADING_LOGS,
    payload: {}
  });

  let query = ``;

  if (options.bookId !== undefined) query = `${query}&bookId=${options.bookId}`;

  if (options.event !== undefined) query = `${query}&event=${options.event}`;

  const route = `view${query ? `?${query.slice(1)}` : ``}`;

  const {
    data: { logMap }
  } = await axios.get(route);

  dispatch({ type: FETCH_LOGS, payload: { logMap } });

  if (callback) callback();
};
